import { render, staticRenderFns } from "./OfferMain.vue?vue&type=template&id=0f196144&"
import script from "./OfferMain.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OfferMain.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OfferMain.vue?vue&type=style&index=0&id=0f196144&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports